import { z } from "zod"

export const NotificationSchema = z.object({
  id: z.number(),
  class: z.string(),
  key: z.string(),
  message: z.string(),
  seen: z.boolean(),
  read: z.boolean(),
  user_id: z.number(),
  created_at: z.number(),
  url: z.string(),
  timeago: z.string(),
})

export type Notification = z.infer<typeof NotificationSchema>

export const NotificationCountSchema = z.object({
  count: z.number(),
})

export type NotificationCount = z.infer<typeof NotificationCountSchema>
